import DOMPurify from "dompurify";
import type { Location } from "../Client";
export const Popup = ({ loc }: { loc: Location }) => {
    return (
        <pre class="popup">
            {loc.routeId === "-1" ? (
                <input type="checkbox" data-id={loc.id} data-select />
            ) : (
                ""
            )}{" "}
            <span
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(loc.text, {
                        ADD_ATTR: ["target"],
                    }),
                }}
            />
        </pre>
    );
};
